<template>
  <v-container>
    <div>
      <v-row v-if="enableSemFaturamentoWeb">
        <v-col
          id="componenteClienteSemFaturamento"
          cols="12"
          sm="12"
          md="12"
          lg="6"
        >
          <v-card
            id="cardDashbord"
            class="mx-auto"
            outlined
          >
            <div class="card-header-dashbord">
              <v-row>
                <v-col
                  cols="12"
                  sm="10"
                  md="10"
                  lg="10"
                  class="d-flex flex-wrap"
                >
                  Quais meus clientes que não compraram no mês?
                </v-col>
                <v-col
                  cols="12"
                  sm="2"
                  md="2"
                  lg="2"
                  class="d-flex justify-end"
                >
                  <v-tooltip
                    top
                    max-width="400"
                    width="400"
                  >
                    <template
                      v-slot:activator="{ on, attrs }"
                    >
                      <v-icon
                        id="iconInformationFatxMetaComercial4"
                        class="text-left"
                        v-bind="attrs"
                        v-on="on"
                        @mouseover="enableTexto('163')"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <div
                      v-if="!carregandoTooltip"
                      v-html="textoOrientacao"
                    />
                  </v-tooltip>
                </v-col>
              </v-row>
            </div>
            <v-card-actions>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <div
                    v-if="loading"
                    :style="styleObject"
                    class="text-center"
                  >
                    <v-icon
                      light
                      class="custom-loader"
                      :style="styleObject"
                    >
                      mdi-cached
                    </v-icon>
                    Carregando dados...
                  </div>
                  <div
                    v-else-if="error"
                    class="alert alert-danger"
                  >
                    {{ error }}
                  </div>
                  <div
                    v-else
                  >
                    <v-card>
                      <v-card-title>
                        <span>Quantidade Clientes: {{ clientesSemFaturamento.length }}</span>
                      </v-card-title>
                      <div
                        id="idTable"
                        style="overflow-x: auto; max-width: 100%;"
                      >
                        <table
                          style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
                          class="elevation-1"
                        >
                          <thead>
                            <tr>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;"
                                class="black--text title"
                              >
                                Segmento
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;"
                                class="black--text title"
                              >
                                Cliente
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;"
                                class="black--text title"
                              >
                                Dias sem faturamento
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in clientesSemFaturamento"
                              :key="item.id"
                            >
                              <td
                                id="dadoMovimentacao"
                                style="text-align: left;"
                              >
                                {{ item.segmento_cliente }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: left;"
                              >
                                {{ item.nome_cliente }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right;"
                              >
                                {{ item.dias }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </v-card>
                    <router-link
                      id="iconeLinkSemFaturamentoPrint"
                      to="/clientes/detalhe-cliente-sem-faturamento"
                      :style="styleObject"
                    >
                      <div
                        id="linkDetalheClienteSemFaturamento"
                        class="text-center"
                      >
                        <v-icon
                          id="iconLinkClienteSemFaturamento"
                          class="text-center"
                        >
                          mdi-chevron-double-down
                        </v-icon><br>
                      </div>
                    </router-link>
                  </div>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          id="componenteClienteSemFaturamento"
          cols="12"
          sm="12"
          md="12"
          lg="6"
        >
          <v-card
            id="cardDashbord"
            class="mx-auto"
            outlined
          >
            <div class="card-header-dashbord">
              <v-row>
                <v-col
                  cols="12"
                  sm="10"
                  md="10"
                  lg="10"
                  class="d-flex flex-wrap"
                >
                  Quais clientes estão prestes a inativar?
                </v-col>
                <v-col
                  cols="12"
                  sm="2"
                  md="2"
                  lg="2"
                  class="d-flex justify-end"
                >
                  <v-tooltip
                    top
                    max-width="400"
                    width="400"
                  >
                    <template
                      v-slot:activator="{ on, attrs }"
                    >
                      <v-icon
                        id="iconInformationFatxMetaComercial4"
                        class="text-left"
                        v-bind="attrs"
                        v-on="on"
                        @mouseover="enableTexto('164')"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <div
                      v-if="!carregandoTooltip"
                      v-html="textoOrientacao"
                    />
                  </v-tooltip>
                </v-col>
              </v-row>
            </div>
            <v-card-actions>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <div
                    v-if="loading"
                    :style="styleObject"
                    class="text-center"
                  >
                    <v-icon
                      light
                      class="custom-loader"
                      :style="styleObject"
                    >
                      mdi-cached
                    </v-icon>
                    Carregando dados...
                  </div>
                  <div
                    v-else-if="error"
                    class="alert alert-danger"
                  >
                    {{ error }}
                  </div>
                  <div
                    v-else
                  >
                    <v-card>
                      <v-card-title>
                        <span>Quantidade Clientes: {{ clientesInativo.length }}</span>
                      </v-card-title>
                      <div
                        id="idTable"
                        style="overflow-x: auto; max-width: 100%;"
                      >
                        <table
                          style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
                          class="elevation-1"
                        >
                          <thead>
                            <tr>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;"
                                class="black--text title"
                              >
                                Segmento
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;"
                                class="black--text title"
                              >
                                Cliente
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;"
                                class="black--text title"
                              >
                                Dias sem faturamento
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in clientesInativo"
                              :key="item.id"
                            >
                              <td
                                id="dadoMovimentacao"
                                style="text-align: left;"
                              >
                                {{ item.segmento_cliente }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: left;"
                              >
                                {{ item.nome_cliente }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right;"
                              >
                                {{ item.dias }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </v-card>
                    <router-link
                      id="iconeLinkSemFaturamentoPrint"
                      to="/clientes/detalhe-cliente-proximo-inativar"
                      :style="styleObject"
                    >
                      <div
                        id="linkDetalheClienteSemFaturamento"
                        class="text-center"
                      >
                        <v-icon
                          id="iconLinkClienteSemFaturamento"
                          class="text-center"
                        >
                          mdi-chevron-double-down
                        </v-icon><br>
                      </div>
                    </router-link>
                  </div>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row
        v-if="enableSemFaturamentoPrint"
        id="clienteSemFaturamentoPrint"
      >
        <v-col
          id="clientesSemFatPrint"
          cols="12"
          sm="6"
          md="6"
          lg="6"
        >
          <v-row id="clientesNaoFaturados">
            <v-col
              id="clientesNaoFaturadosPrint"
              cols="11"
              class="text-left"
            >
              <v-icon
                id="iconInformationClientesNaoFaturados"
                class="text-left"
              >
                mdi-currency-usd
              </v-icon>
              Quais meus clientes que não compraram no mês?
            </v-col>
            <v-col
              cols="1"
              class="text-right"
            >
              <v-tooltip
                top
                max-width="400"
                width="400"
              >
                <template
                  v-slot:activator="{ on, attrs }"
                >
                  <v-icon
                    id="iconInformationClientesNaoFaturados"
                    class="text-left"
                    v-bind="attrs"
                    v-on="on"
                    @mouseover="enableTexto('163')"
                  >
                    mdi-information-outline
                  </v-icon>
                </template>
                <div
                  v-if="!carregandoTooltip"
                  v-html="textoOrientacao"
                />
              </v-tooltip>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headersClientes"
            :items="clientesSemFaturamento"
            :items-per-page="clientesSemFaturamento.length"
            fixed-header
            disable-sort
            hide-default-footer
            class="elevation-1"
            style="color: black"
          />
        </v-col>
        <v-col
          id="clientesInativoFatPrint"
          cols="12"
          sm="6"
          md="6"
          lg="6"
        >
          <v-row id="clientesProximoInativar">
            <v-col
              id="clientesProximoInativarPrint"
              cols="11"
              class="text-left"
            >
              <v-icon
                id="iconInformationClientesProximoInativar"
                class="text-left"
              >
                mdi-clipboard-alert
              </v-icon>
              Quais clientes estão prestes a inativar?
            </v-col>
            <v-col
              cols="1"
              class="text-right"
            >
              <v-tooltip
                top
                max-width="400"
                width="400"
              >
                <template
                  v-slot:activator="{ on, attrs }"
                >
                  <v-icon
                    id="iconInformationclientesProximoInativar"
                    class="text-left"
                    v-bind="attrs"
                    v-on="on"
                    @mouseover="enableTexto('164')"
                  >
                    mdi-information-outline
                  </v-icon>
                </template>
                <div
                  v-if="!carregandoTooltip"
                  v-html="textoOrientacao"
                />
              </v-tooltip>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headersClientes"
            :items="clientesInativo"
            :items-per-page="clientesInativo.length"
            fixed-header
            disable-sort
            hide-default-footer
            class="elevation-1"
            style="color: black"
          />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
  import Clientes from '../../../../../services/clientes'
  import Permissao from '../../../../../services/menu'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowClientesSemFaturamento',
    emits: ['enableDadosSemFaturamento'],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      vendedorSelect: [],
      areaSelect: [],
      redeSelect: [],
      supervisorSelect: [],
      receita: [],
      segmento: [],
      categoria: [],
      promotor: [],
      textoPartipantesSemFat: '',
      textoPartipantesInativos: '',
      orientacao: JSON.parse(localStorage.getItem('orientacaoPartipantes')),
      codigo: 0,
      headersClientes: [
        { text: 'Segmento', value: 'segmento_cliente', class: 'black--text title' },
        { text: 'Cliente', value: 'nome_cliente', class: 'black--text title' },
        { text: 'Dias sem faturamento', value: 'dias', align: 'right', class: 'black--text title' },
      ],
      clientesSemFaturamento: [],
      clientesInativo: [],
      clientesSemFaturamentoPrint: [],
      clientesInativoPrint: [],
      enableSemFaturamentoPrint: false,
      enableSemFaturamentoWeb: true,
      dynamicPaddingCliente5: '',
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    created () {
      eventEmit.$on('set_faturamento_novos_clientes', this.handleUpdateDados)

      eventEmit.$on('enable-print', this.handleEnablePrint)

      eventEmit.$on('disable-print', this.handleDisablePrint)
    },

    beforeDestroy () {
      eventEmit.$off('set_faturamento_novos_clientes', this.handleUpdateDados)

      eventEmit.$off('enable-print', this.handleEnablePrint)

      eventEmit.$off('disable-print', this.handleDisablePrint)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      this.updateDynamicPadding()

      window.addEventListener('resize', this.updateDynamicPadding)
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingCliente5 = 'padding-right: 30rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingCliente5 = 'padding-right: 11.4rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingCliente5 = 'padding-right: 4rem !important'
        } else {
          this.dynamicPaddingCliente5 = 'padding-right: 13.1rem !important'
        }
      },

      handleUpdateDados (primeiroDia, dataFinal, select, vendedor, area, rede, supervisor, receita, segmento, categoria, promotor) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.vendedorSelect = vendedor
        this.areaSelect = area
        this.redeSelect = rede
        this.supervisorSelect = supervisor
        this.receita = receita
        this.segmento = segmento
        this.categoria = categoria
        this.promotor = promotor

        this.showDadosClientesSemFaturamento()
      },

      handleEnablePrint (value) {
        this.enableSemFaturamentoPrint = value
        this.enableSemFaturamentoWeb = false
      },

      handleDisablePrint (value) {
        this.enableSemFaturamentoPrint = false
        this.enableSemFaturamentoWeb = value
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      async showDadosClientesSemFaturamento () {
        this.loading = true
        this.clientesSemFaturamento = []
        this.clientesInativo = []

        await Clientes.showClientesSemFaturamento(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato, this.vendedorSelect, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receita, this.segmento, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.clientesSemFaturamento = resposta.data.dadosClientes

            this.clientesInativo = resposta.data.dadosClientesInativos

            for (var i = 0; i < 37 && i < this.clientesSemFaturamento.length; i++) {
              this.clientesSemFaturamentoPrint.push(this.clientesSemFaturamento[i])
            }

            for (var j = 0; j < 37 && j < this.clientesInativo.length; j++) {
              this.clientesInativoPrint.push(this.clientesInativo[j])
            }
          } else if (resposta.data.msg === 'Não há dados no período selecionado') {
            this.clientesSemFaturamento = []
            this.clientesInativo = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false

          eventEmit.$emit('enable-dados-sem-faturamento', this.headersClientes, this.clientesSemFaturamento, this.clientesInativo)
        })
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px !important;
    }

    th, td {
      padding: 8px;
      word-wrap: break-word;
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

   #dadoMovimentacao {
    font-size: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
    word-wrap: break-word;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #clientesSemFatPrint {
    margin: 2rem 0 14rem 0
  }

  #clientesInativoFatPrint {
    margin: 2rem 0 14rem 0
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  #listItemClienteSemFaturamento {
    margin: -2rem 0 0 -1rem;
  }

  #componenteClienteSemFaturamento {
    margin: -2rem 0 0 0rem;
  }

  /* #headersClientesFaturadosPrint {
    display: none;
  }

  #headersClientesInativoPrint {
    display: none;
  } */

  /* #clienteSemFaturamentoPrint {
    display: none;
  } */
</style>
